import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../utils/api';

/* ─── PALETTE ─────────────────────────────────────────────── */
const V1 = '#7F00FF';
const V2 = '#B163FF';
const V3 = '#51158C';
const V4 = '#2B0057';

/* ─── SVG ICONS ───────────────────────────────────────────── */
const UsersIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const BookOpenIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);
const ClipboardIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
  </svg>
);
const ClockIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);
const CheckCircleIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const AwardIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6" /><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
  </svg>
);
const MegaphoneIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 11l18-5v12L3 14v-3z" /><path d="M11.6 16.8a3 3 0 0 1-5.8-1.6" />
  </svg>
);
const CodeIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" />
  </svg>
);
const TagIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41L13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <circle cx="7" cy="7" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);
const ArrowRightIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);
const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
  </svg>
);

/* ─── CIRCUIT BG ──────────────────────────────────────────── */
const CircuitBg = () => (
  <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 0, opacity: 0.07 }}>
    <svg viewBox="0 0 1400 800" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style={{ width: '100%', height: '100%' }}>
      <g stroke={V2} strokeWidth="0.9" fill="none">
        <line x1="0" y1="160" x2="320" y2="160" /><line x1="380" y1="160" x2="680" y2="160" />
        <line x1="980" y1="120" x2="1400" y2="120" />
        <line x1="0" y1="420" x2="210" y2="420" /><line x1="570" y1="420" x2="880" y2="420" />
        <line x1="320" y1="0" x2="320" y2="260" /><line x1="680" y1="120" x2="680" y2="260" />
        <circle cx="320" cy="160" r="5" fill={V1} opacity="0.9" />
        <circle cx="680" cy="160" r="4" fill={V2} opacity="0.9" />
        <circle cx="210" cy="420" r="4" fill={V2} opacity="0.9" />
      </g>
    </svg>
  </div>
);

const statsConfig = [
  { key: 'totalStudents',       label: 'Total Students',   Icon: UsersIcon,      accent: V2            },
  { key: 'totalCourses',        label: 'Total Courses',    Icon: BookOpenIcon,   accent: '#3b82f6'     },
  { key: 'totalApplications',   label: 'Applications',     Icon: ClipboardIcon,  accent: 'var(--warning)' },
  { key: 'pendingApplications', label: 'Pending',          Icon: ClockIcon,      accent: 'var(--danger)'  },
  { key: 'completedApplications',label: 'Completed',       Icon: CheckCircleIcon,accent: 'var(--success)' },
  { key: 'totalCertificates',   label: 'Certificates',     Icon: AwardIcon,      accent: V2            },
];

const statusConfig = {
  pending:          { label: 'Pending',          color: 'var(--warning)', bg: 'rgba(245,166,35,0.12)',  border: 'rgba(245,166,35,0.3)'  },
  payment_verified: { label: 'Payment Verified', color: '#3b82f6',        bg: 'rgba(59,130,246,0.12)',  border: 'rgba(59,130,246,0.3)'  },
  approved:         { label: 'Approved',         color: 'var(--success)', bg: 'rgba(13,186,121,0.12)', border: 'rgba(13,186,121,0.3)'  },
  rejected:         { label: 'Rejected',         color: 'var(--danger)',  bg: 'rgba(240,65,85,0.12)',  border: 'rgba(240,65,85,0.3)'   },
  completed:        { label: 'Completed',        color: 'var(--badge-pill-text)', bg: 'var(--badge-pill-bg)', border: 'var(--badge-pill-border)' },
};

const AdminDashboard = () => {
  const [stats, setStats]       = useState(null);
  const [recentApps, setRecentApps] = useState([]);

  useEffect(() => {
    API.get('/admin/stats').then(r => setStats(r.data)).catch(() => {});
    API.get('/admin/applications?limit=5').then(r => setRecentApps(r.data.applications || [])).catch(() => {});
  }, []);

  return (
    <div style={{ background: 'var(--bg)', color: 'var(--text)', minHeight: '100vh' }}>

      {/* ══ HEADER ══════════════════════════════════════════ */}
      <section style={{ padding: '120px 0 60px', position: 'relative', overflow: 'hidden', background: 'var(--bg)' }}>
        <CircuitBg />
        <div style={{ position: 'absolute', bottom: 0, right: 0, width: 360, height: 360, borderRadius: '50%', background: `radial-gradient(circle, var(--hero-orb) 0%, transparent 70%)`, pointerEvents: 'none' }} />
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="section-label">ADMIN PANEL</div>
          <h1 style={{
            fontSize: 'clamp(28px,4vw,48px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 8,
            fontFamily: "'Inter',sans-serif",
          }}>
            Admin <span style={{ background: `linear-gradient(135deg,${V1},${V2})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Dashboard</span>
          </h1>
          <p style={{ color: 'var(--muted)', fontSize: 15 }}>ThiranX Control Center — manage applications, courses, and certificates.</p>
        </div>
      </section>

      {/* ══ STATS + QUICK LINKS ══════════════════════════════ */}
      <section style={{ padding: '0 0 80px', background: 'var(--bg2)', borderTop: '1px solid var(--border)' }}>
        <div className="container" style={{ paddingTop: 48 }}>

          {/* Stats Grid */}
          {stats && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))', gap: 16, marginBottom: 40 }}>
              {statsConfig.map(({ key, label, Icon, accent }) => (
                <div key={key} style={{
                  background: 'var(--card-solid)', border: '1px solid var(--border)',
                  borderRadius: 18, padding: '24px 20px',
                  boxShadow: 'var(--shadow-card)',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  textAlign: 'center',
                }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = 'var(--shadow-hover)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = 'var(--shadow-card)'; }}
                >
                  <div style={{
                    width: 52, height: 52, borderRadius: 14, margin: '0 auto 14px',
                    background: 'var(--badge-pill-bg)', border: '1px solid var(--badge-pill-border)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: accent,
                  }}>
                    <Icon size={22} />
                  </div>
                  <div style={{
                    fontFamily: "'Inter',sans-serif", fontWeight: 900,
                    fontSize: 36, lineHeight: 1, color: accent, marginBottom: 6,
                  }}>
                    {stats[key] ?? 0}
                  </div>
                  <div style={{ color: 'var(--muted)', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                    {label}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Quick Links */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 16, marginBottom: 48 }}>
            {[
              { to: '/admin/applications', Icon: ClipboardIcon, title: 'Manage Applications', desc: 'Review, approve, and assign batches to students.' },
              { to: '/admin/courses',      Icon: BookOpenIcon,  title: 'Manage Courses',     desc: 'Add, edit, or delete courses from the platform.' },
              { to: '/admin/students',     Icon: UsersIcon,     title: 'Manage Students',    desc: 'View registered student profiles and manage accounts.' },
              { to: '/admin/microinternships', Icon: AwardIcon, title: 'Microinternships',   desc: 'Secret PIN-protected panel for ₹100 microinternships.' },
              { to: '/admin/announcement', Icon: MegaphoneIcon, title: 'Announcement Banner', desc: 'Publish, edit, or take down the homepage announcement.' },
              { to: '/admin/dsa', Icon: CodeIcon, title: 'DSA Program', desc: 'Verify payments to unlock the DSA Mastery Program for students.' },
              { to: '/admin/aptitude', Icon: ClipboardIcon, title: 'Aptitude Practice', desc: 'Verify payments to unlock the ₹49 Aptitude Practice pack.' },
              { to: '/admin/card-pricing', Icon: TagIcon, title: 'Edit Card Price', desc: 'Set old/new prices for the DSA, Aptitude, and Microinternship cards.' },
            ].map(({ to, Icon, title, desc }) => (
              <Link key={to} to={to} style={{
                display: 'block', textDecoration: 'none',
                background: 'var(--card-solid)', border: '1px solid var(--border)',
                borderRadius: 20, padding: '28px 24px',
                boxShadow: 'var(--shadow-card)',
                transition: 'border-color 0.25s, transform 0.25s, box-shadow 0.25s',
              }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--border-strong)'; e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = 'var(--shadow-hover)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = 'var(--shadow-card)'; }}
              >
                <div style={{
                  width: 52, height: 52, borderRadius: 14, marginBottom: 16,
                  background: `linear-gradient(135deg,${V4},${V3})`,
                  border: `1px solid ${V1}44`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: V2,
                }}>
                  <Icon size={22} />
                </div>
                <h3 style={{ fontSize: 16, fontWeight: 800, marginBottom: 6, fontFamily: "'Inter',sans-serif", color: 'var(--text)' }}>{title}</h3>
                <p style={{ color: 'var(--muted)', fontSize: 13.5, lineHeight: 1.55 }}>{desc}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 16, color: V2, fontSize: 13, fontWeight: 700 }}>
                  Go to section <ArrowRightIcon />
                </div>
              </Link>
            ))}
          </div>

          {/* Recent Applications */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
            <h2 style={{ fontSize: 'clamp(20px,2.5vw,28px)', fontWeight: 800, letterSpacing: '-0.02em', fontFamily: "'Inter',sans-serif" }}>
              Recent Applications
            </h2>
            <Link to="/admin/applications" style={{ display: 'flex', alignItems: 'center', gap: 6, color: V2, fontSize: 13.5, fontWeight: 700 }}>
              View all <ArrowRightIcon />
            </Link>
          </div>

          {recentApps.length === 0 ? (
            <div style={{
              textAlign: 'center', padding: '60px 24px',
              background: 'var(--card-solid)', border: '1px solid var(--border)', borderRadius: 20,
              color: 'var(--muted)', fontSize: 15,
            }}>
              No applications yet
            </div>
          ) : (
            <div style={{
              background: 'var(--card-solid)', border: '1px solid var(--border)',
              borderRadius: 20, overflow: 'hidden',
              boxShadow: 'var(--shadow-card)',
            }}>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid var(--border)', background: 'var(--bg3)' }}>
                      {['Student', 'Course', 'Amount', 'Status', 'Date', 'Action'].map(h => (
                        <th key={h} style={{
                          padding: '14px 18px', textAlign: 'left',
                          color: 'var(--muted)', fontSize: 11.5, fontWeight: 800,
                          textTransform: 'uppercase', letterSpacing: '0.07em',
                          whiteSpace: 'nowrap',
                        }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {recentApps.map((app, i) => {
                      const st = statusConfig[app.status] || statusConfig.pending;
                      return (
                        <tr key={app._id} style={{
                          borderBottom: i < recentApps.length - 1 ? '1px solid var(--border)' : 'none',
                          transition: 'background 0.15s',
                        }}
                          onMouseEnter={e => e.currentTarget.style.background = 'var(--bg3)'}
                          onMouseLeave={e => e.currentTarget.style.background = ''}
                        >
                          <td style={{ padding: '16px 18px' }}>
                            <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text)' }}>{app.student?.name || app.studentName}</div>
                            <div style={{ color: 'var(--muted)', fontSize: 12, marginTop: 2 }}>{app.student?.email || app.studentEmail}</div>
                          </td>
                          <td style={{ padding: '16px 18px', color: 'var(--text-2)', fontSize: 14 }}>{app.course?.title}</td>
                          <td style={{ padding: '16px 18px', color: V2, fontWeight: 700, fontSize: 14 }}>₹{app.amountPaid?.toLocaleString()}</td>
                          <td style={{ padding: '16px 18px' }}>
                            <span style={{
                              display: 'inline-flex', padding: '4px 12px', borderRadius: 999,
                              fontSize: 11.5, fontWeight: 700,
                              color: st.color, background: st.bg, border: `1px solid ${st.border}`,
                            }}>{st.label}</span>
                          </td>
                          <td style={{ padding: '16px 18px', color: 'var(--muted)', fontSize: 13, whiteSpace: 'nowrap' }}>
                            {new Date(app.createdAt).toLocaleDateString('en-IN')}
                          </td>
                          <td style={{ padding: '16px 18px' }}>
                            <Link to={`/admin/applications/${app._id}`} style={{
                              display: 'inline-flex', alignItems: 'center', gap: 6,
                              padding: '7px 14px', borderRadius: 8,
                              border: '1.5px solid var(--border-strong)',
                              color: V2, fontSize: 13, fontWeight: 700,
                              fontFamily: "'Satoshi','DM Sans',sans-serif",
                              transition: 'all 0.2s',
                            }}
                              onMouseEnter={e => { e.currentTarget.style.background = V1; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = V1; }}
                              onMouseLeave={e => { e.currentTarget.style.background = ''; e.currentTarget.style.color = V2; e.currentTarget.style.borderColor = 'var(--border-strong)'; }}
                            >
                              <EyeIcon /> View
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
